import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import toast from "react-hot-toast";
import ReactJsonTree from "../Eligibility/components/ReactJsonTree";
import axios from "axios";
import Pagination from "../../components/Pagination";
import { useTranslation } from "react-i18next";
import AppTable from "../../shared/AppTable";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ClaimUploadErrorModal({
  open,
  setOpen,
  handleClose,
  selectedItem,
}) {
  const { t } = useTranslation();
  const [showJsonView, setShowJsonView] = useState(false);
  const [jsonObject, setJsonObject] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 5;
  const [loadingFile, setLoadingFile] = useState(false);
  const [uploadData, setUploadData] = useState([]);
  const [jsonDialogOpen, setJsonDialogOpen] = useState(false);

  const getUploadErrors = async (page) => {
    const token = localStorage.getItem("token");
    const tokenWithoutQuotes = token ? token.replace(/"/g, "") : "";
    if (!token) {
      console.error(t("Token not found in local storage."));
      return;
    }
    try {
      setLoadingFile(true);
      const response = await axios.get(
        `https://api.supergitsa.com/api/claim/excel/errors?excel_id=${selectedItem.ReferenceNo}&page=${page}&limit=${itemsPerPage}`,
        { headers: { Authorization: `Bearer ${tokenWithoutQuotes}` } },
      );
      setLoadingFile(false);
      setUploadData(response?.data?.data);
      setTotalPages(Math.ceil(response?.data?.count / itemsPerPage));
    } catch (error) {
      setLoadingFile(false);
      toast.error(error?.response?.data?.error);
    }
  };

  useEffect(() => {
    if (selectedItem && selectedItem.ReferenceNo) {
      getUploadErrors(currentPage);
    }
  }, [selectedItem, currentPage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const columns = [
    {
      header: t("SQ #"),
      render: (row, index) => index + 1,
    },
    { header: t("Sheet Name"), field: "SheetName" },
    { header: t("Column Name"), field: "ColumnName" },
    { header: t("Row Number"), field: "RowNumber" },
    {
      header: t("Error"),
      render: (row) => (
        <span className="text-red-600 font-medium text-xs">{row?.Error}</span>
      ),
    },
  ];

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={() => {
          jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
        }}
        TransitionComponent={Transition}
        style={{ zIndex: 100 }}
      >
        {/* AppBar Header */}
        <AppBar sx={{ position: "relative", backgroundColor: "#0070C2" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography
              sx={{ ml: 2, flex: 1, fontSize: "0.9rem", fontWeight: 700 }}
              component="div"
            >
              {t("Claim Upload Errors")}
            </Typography>
            <Button
              autoFocus
              color="inherit"
              size="small"
              onClick={() => {
                jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
              }}
              sx={{ fontWeight: 600, fontSize: "0.75rem" }}
            >
              {t("Close")}
            </Button>
          </Toolbar>
        </AppBar>

        {/* Content */}
        {loadingFile ? (
          <div className="flex items-center justify-center h-40 text-gray-500 text-sm">
            {t("Loading...")}
          </div>
        ) : (
          <>
            {jsonDialogOpen ? (
              <div className="p-4">
                <ReactJsonTree data={jsonObject} />
              </div>
            ) : (
              <div className="p-4">
                <AppTable
                  columns={columns}
                  data={uploadData}
                  loading={loadingFile}
                  actions={false}
                />
                <div className="mt-2">
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </Dialog>
    </div>
  );
}
